module.exports = __webpack_public_path__ + "static/media/googleplus.72ee30ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/FooterSection/googleplus.svg
// module id = 1084
// module chunks = 1